import { StyledTreeItem } from '../../atoms/Tree/Component';
import { getFieldsOfParentFields } from '../../../store/constructs/fields/selectors'
import { useDispatch, useSelector } from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';
import Grid from '@material-ui/core/Grid';
import ActionIcons from '../../atoms/Tree/ActionIcons';
import { setElementToCopy, handleSnackBar, handleTopRightInfo } from '../../../store/global/actions';
import { getElementOnFocus, getElementToCopy } from '../../../store/global/selectors';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import IconButton from '@material-ui/core/IconButton';
import { invokePostService } from '../../../store/global/actions'
import { typeItems, otherDisplayTypes, urlItems } from "../../../config/fields"

// const scrollToTop = () => {
//   console.log('CLICKED')
//   window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
// }

const FieldItem = ({ field, setAction, messageId, index, totalFields, event, allFields, allMessages, onSuccess }) => {

  // console.log("field------->", field)

  const dispatch = useDispatch();
  const elementToCopy = useSelector(getElementToCopy);
  const fieldsOfParentField = useSelector(getFieldsOfParentFields(field))
  const elementOnFocus = useSelector(getElementOnFocus);
  const displayType = otherDisplayTypes.find(item => item.value == field.attributes?.type);
  const universalType = typeItems.find(item => item.value == field.attributes?.type);
  const urlType = urlItems.find(item => item.value == field.attributes?.type);
  const messageAsType = allMessages?.find(item => item._id == field.attributes?.type);
  const typeOfField = displayType ? displayType.title : universalType ? universalType.title : urlType ? urlType.title : messageAsType ? messageAsType.name : field.attributes?.type;
  let fieldName = '';
  const messageIds = allMessages?.map(item => item._id) || [];

  const scrollToTheTop = () => {
    // window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    var myDiv = document.getElementById('bcrumb');
    myDiv?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });

  }
  



  const copyItem = ({ id, ...rest }) => {
    dispatch(setElementToCopy({ id, type: 'field' }));
    dispatch(handleSnackBar({ open: true, message: "Item copied", severity: "success" }));
  }

  const fieldTypes = ['BOOL', 'UINT8', 'UINT16', 'UINT32', 'UINT64', 'INT8', 'INT16', 'INT32', 'INT64', 'COUNTER', 'FLOAT', 'DOUBLE', 'GAUGE', 'OCTETSTRING', 'STRING', 'TEXTSTRING', 'DATETIME', 'TIMESTAMP']

  /** On paste click */
  const pasteItem = ({ id, ...rest }) => {
    dispatch(handleTopRightInfo({ message: "Updating section..", open: true, }));
    const rootParent = elementOnFocus.id;
    const rootParentType = elementOnFocus.type;
    dispatch(invokePostService('pasteField', { fieldId: elementToCopy.id, parentId: id, rootParent, rootParentType }, [])).then(res => {
      dispatch(handleTopRightInfo({ open: false }));
      if (res?.status) {
        dispatch(handleSnackBar({ open: true, message: "Section updated", severity: "success" }));
        setAction({});
        onSuccess();
      } else {
        if (res?.code === 255) {
          setAction({});
        }
      }
    });

  }


  let actions = {
    add: { id: field._id, action: 'create_field', tooltip: 'Add a field', item: 'field', perform: setAction, disabled: event?.messageFromTemplate ? true : false },
    // edit: { id: field._id, action: 'edit_field', tooltip: 'Edit field', item: 'field', perform: setAction },
    delete: { id: field._id, element: field, action: 'delete_field', tooltip: 'Delete field', item: 'field', perform: setAction, disabled: event?.messageFromTemplate ? true : false },
  }
  if (messageId === undefined) {
    actions.copy = { id: field._id, element: field, action: 'copy_field', tooltip: 'Copy this field', item: 'field', perform: copyItem, disabled: event?.messageFromTemplate ? true : false }
  }

  if (elementToCopy != null && elementToCopy.type == 'field' && !fieldTypes.includes((field.attributes?.type || '').toUpperCase())) {
    actions = { ...actions, paste: { id: field._id, tooltip: 'Paste copied item', perform: pasteItem, disabled: false } }
  }

  if (fieldTypes.includes((field.attributes?.type || '').toUpperCase()) || messageIds.includes(field.attributes?.type)) {

    actions = {
      ...actions,
      add: { id: field._id, action: 'create_field', tooltip: 'Add a field', item: 'field', perform: setAction, disabled: true },

    }
  }


  const fieldHolder = {
    'display': 'inline-block',
    'white-space': 'nowrap',
    'overflow': 'hidden',
    'text-overflow': 'ellipsis',
    'paddingLeft': '10px', 
    'paddingTop': '10px',
    'paddingBottom': '10px'
    // 'borderRight': 'solid 1px #ccc'
  }

  const setActionEdit = (e) => {

    setAction({ action: 'edit_field', id: field._id, item: field })
    if (e.target.closest('li') !== undefined && e.target.closest('li').classList.contains('Mui-expanded') == true) {
      e.preventDefault();
    }
  }

  const moveFieldUp = (field) => {
    const parentId = field.parent[0].id;
    const parentType = field.parent[0].type;
    dispatch(handleTopRightInfo({ message: "Moving field..", open: true, }));
    const payload = { 
      direction: 'up', 
      parentId, 
      parentType 
    }
    if(messageId) payload.messageId = messageId;
    dispatch(invokePostService('moveField', payload, [field._id])).then(res => {
      dispatch(handleTopRightInfo({ open: false }));
      if (res?.status) {
        dispatch(handleSnackBar({ open: true, message: "Field moved", severity: "success" }));
        setAction({});
        onSuccess();
      } else {
        if (res?.code === 255) {
          setAction({});
        }
      }
    });
  }

  const moveFieldDown = (field) => {
    const parentId = field.parent[0].id;
    const parentType = field.parent[0].type;
    dispatch(handleTopRightInfo({ message: "Moving field..", open: true, }));
    dispatch(invokePostService('moveField', { direction: 'down', parentId, parentType }, [field._id])).then(res => {
      dispatch(handleTopRightInfo({ open: false }));
      if (res?.status) {
        dispatch(handleSnackBar({ open: true, message: "Field moved", severity: "success" }));
        setAction({});
        onSuccess();
      } else {
        if (res?.code === 255) {
          setAction({});
        }
      }
    });
  }

  const sortArrowStyle = {
    fontSize: 14,
    margin: 'auto',
    color: '#4791db'
  }

  const buttonContainerStyle={
    'paddingTop': '10px',
    'paddingBottom': '10px'
  }

  const fieldContainerStyle = {
    paddingRight: '10px'
  }

  const iconBtnStyle = {
    minWidth: '33px !important',
    width: 33
  }

  return (
    <Grid container  spacing={12} style={fieldContainerStyle} id={`field_node_${field?.name}`} className={`field_node_${field?.name}`} >
      <Grid  style={fieldHolder} item xs={8} alignItems="left" onClick={e => { setActionEdit(e); scrollToTheTop() }} title={field.attributes?.desc}>
        {field.name}{!field.attributes?.optional && messageId && <span style={{ color: 'red' }}>*</span>}<br /><i color="primary">{typeOfField}</i>
      </Grid>
      <Grid item xs={2} justify="flex-end" className={"menu_button"} style={buttonContainerStyle}>
        <ActionIcons actions={actions} messageId={messageId} />
      </Grid>

      <Grid item xs={1} className={"move_up"} style={buttonContainerStyle}>
        {index > 0 && <Tooltip title="Move up">
          <IconButton id={"move_up_button"} style={iconBtnStyle} onClick={e => moveFieldUp(field)}><ArrowUpwardIcon style={sortArrowStyle} /></IconButton>
        </Tooltip>}
      </Grid>

      <Grid item xs={1} className={"move_down"} style={buttonContainerStyle}>
        {index < totalFields - 1 && <Tooltip title="Move down">
          <IconButton id={"move_down_button"} style={iconBtnStyle} onClick={e => moveFieldDown(field)}><ArrowDownwardIcon style={sortArrowStyle} /></IconButton>
        </Tooltip>}
      </Grid>

    </Grid>


  )

}


export default function FieldNode({ allFields, allMessages, field, setAction, messageId, collapseNode, expandNode, index, totalFields, event, onSuccess }) {

  let childFields = allFields?.filter(f => f.parent[0].id == field._id).sort((a, b) => a.order - b.order);

  return (
    <>
      {field != undefined && <StyledTreeItem classes={{label: "MuiTreeItem-label"}} nodeId={field._id} collapseNode={collapseNode} messageName={field.name} expandNode={expandNode} label={<FieldItem allFields={allFields} allMessages={allMessages} field={field} setAction={setAction} messageId={messageId} index={index} totalFields={totalFields} event={event} onSuccess={onSuccess}/>}>

        {childFields?.length > 0 && childFields?.map((field, fieldIndex) => <FieldNode allFields={allFields} allMessages={allMessages} field={field} setAction={setAction} messageId={messageId} index={fieldIndex} totalFields={childFields?.length} collapseNode={collapseNode} expandNode={expandNode} event={event} onSuccess={onSuccess}/>)}
      </StyledTreeItem>}
    </>
  )
}